// 圓餅圖配置
export const pieChartConfig = {
	// 圓餅圖基本設置
	basic: {
		type: "pie",
		name: "量身人數",
		radius: "30%",
		center: ["50%", "35%"],
	},
	
	// 標籤設置
	label: {
		show: true,
		formatter: "{b}",
		color: "#fff",
	},
	
	// 標籤線設置
	labelLine: {
		show: true,
	},
	
	// 強調效果
	emphasis: {
		itemStyle: {
			shadowBlur: 10,
			shadowOffsetX: 0,
			shadowColor: "rgba(0, 0, 0, 0.5)",
		},
	},
	
	// 工具提示設置
	tooltip: {
		show: true,
        trigger: "item",
		formatter: function (params, sourceData, ageRangeColor) {
			// 這裡會由外部傳入的 formatter 函數處理
			return params.formatter ? params.formatter(params, sourceData, ageRangeColor) : "";
		},
	},
	
	// 樣式設置
	itemStyle: {
		borderColor: "#fff",
		borderWidth: 1,
	},
	
	// 年齡範圍樣式
	ageRangeStyles: {
		selected: {
			borderColor: "#333",
			borderWidth: 3,
		},
		default: {
			borderColor: "#fff",
			borderWidth: 1,
		},
		placeholder: {
			color: "#ccc",
			borderColor: "#ccc",
			borderWidth: 1,
		},
	},
	
	// 預設數據（當沒有數據時顯示）
	defaultData: [
		{
			name: "請選擇年齡範圍",
			value: 1,
			totalCount: 0,
			itemStyle: {
				color: "#ccc",
				borderColor: "#ccc",
				borderWidth: 1,
			},
		},
	],
};
